module.exports = __webpack_public_path__ + "static/media/LOGO COMPLETO COLOR.563385ba.png";